<template>
	<div class="news">
		<div class="hot" @click="jump">
			<div class="cat">News</div>
			<div class="info">
				<img :src="newsTop.image_p_top" class="pic" />
				<div class="title">{{newsTop.title}}</div>
				<div class="cont">
                    {{newsTop.summary}}
                </div>
                <div class="next"></div>
			</div>
            <div class="cube"></div>
		</div>
		<div class="past-list">
			<div 
                class="item" 
                v-for="(item, index) in pastList" 
                :key="index"
                @click="() => { handleClick(item) }"
            >
				<div class="date">
					<div class="day">{{getDay(item.news_date)}}</div>
					<div class="year">{{getYear(item.news_date)}}</div>
				</div>
				<div class="cont">
					<div class="title">{{item.title}}</div>
					<div class="line"></div>
					<div class="intro">{{item.summary}}</div>
					<div class="end-line"></div>
				</div>
				<div class="next"></div>
			</div>
			<div class="more" v-if="curList.length > 0" @click="viewMore">查看更多+</div>
			<div class="no-more" v-else>没有更多内容了！</div>
            <!-- <div class="cube"></div> -->
		</div>
	</div>
</template>
<script>
    import { Component, Vue } from "vue-property-decorator";
    import { getNewsList } from '@/api/news.js';

	@Component
	export default class News extends Vue {
        pageNum = 1;
        total = 0;
        pastList = [];
        curList = [];

        jump() {
            this.$router.push({
                path: `/news/${this.newsTop.news_id}`
            });
        }
        
        get newsTop() {
            return this.$store.state.common.newsTop;
        }

        getDay(date) {
            const arr = (date || '').split('-');

            return arr[2] + '/' + arr[1];
        }

        getYear(date) {
            return (date || '').split('-')[0]; 
        }

        handleClick(item) {
            this.$router.push({
                path: `/news/${item.news_id}`
            });
        }

        async getNewsDataList() {
            const { code, data: { count, list }, message } = await getNewsList({ page: this.pageNum });

            if (code == 0) {
                this.total = count;
                this.curList = list;
                this.pastList = [].concat(this.pastList.slice(0), list);
            } else {
                console.log(message);
            }
        }

        viewMore() {
            this.getNewsDataList();
            this.pageNum ++;
        }

        mounted() {
            this.getNewsDataList();
            this.pageNum ++;
        }
	}
</script>
<style lang="scss">
	.news {
		width: 100%;
        overflow: hidden;
        padding-top: 100px;
        box-sizing: border-box;
		.hot {
			width: 800px;
			margin: 0 auto 85px;
			box-shadow: 0 5px 10px 0 rgba(242, 242, 249, 1);
			padding-bottom: 50px;
            position: relative;
            cursor: pointer;
			.cat {
				margin: 52px 0 20px;
                text-indent: -99999px;
                width: 164px;
                height: 44px;
                background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/news/News.png) no-repeat;
			}
			.info {
                position: relative;
                z-index: 10;
                background: #fff;
				.pic {
					width: 800px;
				}
				.title {
					font-size: 24px;
					color: #29292a;
					border-bottom: 1px solid rgba(57, 57, 61, 0.4);
					display: inline-block;
					padding: 32px 0 22px;
					margin: 0 0 22px 25px;
					width: 608px;
					box-sizing: border-box;
					text-overflow: ellipsis;
					overflow: hidden;
                    font-family: PingFangSC-light;
				}
				.cont {
					font-size: 16px;
					color: #29292a;
					padding-left: 24px;
					width: 676px;
					box-sizing: border-box;
					-webkit-line-clamp: 2;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					overflow: hidden;
                    line-height: 25px;
                    font-family: PingFangSC-light;
				}
                .next {
                    width: 118px;
					height: 118px;
                    background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/news/light-arrowx2.png) no-repeat;
                    background-size: 100% 100%;
                    position: absolute;
                    right: 65px;
                    bottom: 77px;
                    cursor: pointer;
                    transition: right 0.1s ease-in-out;
                    &:hover {
                        right: 57px;
                    }
                }
			}
            .cube {
                width: 556px;
                height: 555px;
                background: #fb5000;
                position: absolute;
                background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/news/cubex2.png) no-repeat;
                background-size: 100% 100%;
                right: -180px;
                top: -95px;
                transform: rotate(0deg);
            }
		}
		.past-list {
			width: 100%;
			background: #f6f7f8;
			padding: 121px 0 250px;
            position: relative;
			.item {
				width: 964px;
				margin: 0 auto;
				display: flex;
				position: relative;
                cursor: pointer;
				.date {
					color: #e7e9eb;
                    font-family: arial-black;
				}
				.day {
					font-size: 43px;
                    color:#E7E9EB; 
                    border: 2px solid rgba(231, 233, 235, 1);
                    border-bottom: 0;
                    font-family: arial-black;
                    letter-spacing: 3px;
				}
				.year {
					font-size: 52px;
                    color: #F6F7F8;
                    background: rgba(231, 233, 235, 1);
                    letter-spacing: -3px;
                    text-align: center;
				}
				.cont {
					font-size: 36px;
					color: #29292a;
					margin-left: 36px;
					.title {
						font-size: 24px;
						color: #29292a;
                        font-family: PingFangSC-light;
					}
					.line {
						width: 675px;
						height: 1px;
						background: rgba(57, 57, 61, 0.4);
						margin: 20px 0;
					}
					.intro {
						font-size: 16px;
						color: #29292a;
						-webkit-line-clamp: 2;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						overflow: hidden;
						width: 676px;
                        font-family: PingFangSC-light;
					}
					.end-line {
						width: 90px;
						height: 2px;
						// background: rgba(41, 41, 42, 0.3);
						margin: 34px 0 100px;
					}
				}
				.next {
					width: 119px;
					height: 118px;
                    background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/news/arrow.png) no-repeat;
                    position: absolute;
                    right: 0;
                    top: 50px;
                    display: none;
				}
                &:hover {
                    .day {
                        color: #FB5000;
                        border: 2px solid rgba(251,80,0,1);
                    }
                    .year {
                        color: #F6F7F8;
                        background: #FB5000;
                    }
                    .title {
                        color: #FB5000;
                    }
                    .next {
                        background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/news/light-arrow.png);
                    }
                }
			}
			.more {
				cursor: pointer;
				font-size: 14px;
				color: #29292a;
				width: 66px;
				margin: 0 auto;
				border-bottom: 1px solid transparent;
				padding-bottom: 3px;
                font-family: PingFangSC-light;
                position: relative;
                z-index: 999;
                &:hover {
                    border-bottom: 1px solid #29292a;
                }
			}
            .no-more {
				font-size: 14px;
				color: #29292a;
				padding-bottom: 3px;
                text-align: center;
			}
            .cube {
                width: 556px;
                height: 555px;
                background: #fb5000;
                position: absolute;
                background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/news/cube.png) no-repeat;
                right: 100px;
                bottom: -250px;
                transform: rotate(0deg);
            }
		}
	}
</style>

